"use client"
import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";
import { REACT_GOOGLE_REVIEWS_CSS_CDN_URL } from "@constants/cdn-urls";

const ReactGoogleReviews = dynamic(
   () => import("react-google-reviews").then((module) => module.ReactGoogleReviews),
   { ssr: false }
);

function appendStylesheetOnce(href) {
   if (typeof document === "undefined") return;
   if (document.querySelector(`link[href="${href}"]`)) return;

   const link = document.createElement("link");
   link.rel = "stylesheet";
   link.href = href;
   document.head.appendChild(link);
}

export default function Reviews() {
   const featureWidgetId = "54edc8b0-7e28-46c4-b691-25aacfe914fe";
   const [shouldRenderReviews, setShouldRenderReviews] = useState(false);
   const reviewsSectionRef = useRef(null);

   useEffect(() => {
      const sectionElement = reviewsSectionRef.current;
      if (!sectionElement) {
         return;
      }

      const intersectionObserver = new IntersectionObserver(
         (entries) => {
            const [firstEntry] = entries;
            if (!firstEntry?.isIntersecting) {
               return;
            }

            appendStylesheetOnce(REACT_GOOGLE_REVIEWS_CSS_CDN_URL);
            setShouldRenderReviews(true);
            intersectionObserver.disconnect();
         },
         // Start loading a bit before the user reaches this section.
         { rootMargin: "300px 0px" }
      );

      intersectionObserver.observe(sectionElement);
      return () => intersectionObserver.disconnect();
   }, []);
   
   return (
      <div className="home-tops" ref={reviewsSectionRef}>
         <div className="container">
            <div className="section-title-left">
               <h2>What Our Clients Say</h2>
            </div>
            <div className="row">
               <div className="col-12 reviews-widget-slot">
                  {shouldRenderReviews ? (
                     <ReactGoogleReviews
                        layout="carousel"
                        carouselAutoplay={true}
                        featurableId={featureWidgetId}
                     />
                  ) : null}
               </div>
            </div>
         
         
         </div>
      </div>
   );
}